import {BrandliftStatsStore} from 'client/common/types';
import {Statistics} from 'client/common/types/brandlift/types';

export function getStatistics(state: BrandliftStatsStore): Statistics {
    return state.statistics;
}

export function getUplifts(state: BrandliftStatsStore) {
    return state.statistics.uplifts;
}

export function getIsStatisticsReady(state: BrandliftStatsStore): boolean {
    const {survey, statistics} = state;
    const {state: surveyState} = survey;

    const {base} = statistics;

    return Boolean(surveyState) && typeof base?.before === 'number';
}
